import { render, staticRenderFns } from "./CaseBase.vue?vue&type=template&id=1fb5746c&scoped=true&"
import script from "./CaseBase.vue?vue&type=script&lang=js&"
export * from "./CaseBase.vue?vue&type=script&lang=js&"
import style0 from "./CaseBase.vue?vue&type=style&index=0&id=1fb5746c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb5746c",
  null
  
)

export default component.exports